<template>
  <div>
    <el-table :data="userList" height="calc(100vh - 360px)" size="small">
      <el-table-column label="租户" prop="tenantName" fixed />
      <el-table-column prop="id" width="100px" label="账号ID" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{ scope.row.id }}</span>
          <span v-else>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="topUserId"
        label="顶级合伙人UID"
        align="center"
        width="120"
        fixed="left"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.topUserId || "" }}</span>
        </template>
      </el-table-column>
      <el-table-column width="160px" label="注册时间">
        <template slot-scope="scope">
          {{ scope.row.createTime | moment }}
          <!-- {{timestampToTime(new Date(scope.row.createTime).getTime()) }} -->
        </template>
      </el-table-column>
      <el-table-column width="100px" prop="__registerFrom" label="注册来源">
        <template slot-scope="scope">
          <!-- <span v-if="scope.row.mark" class="red">{{
            scope.row.__registerFrom
          }}</span>
          <span v-else>{{ scope.row.__registerFrom }}</span> -->
          <span>{{ scope.row.__registerFrom }}</span>
        </template></el-table-column
      >

      <!-- <el-table-column prop="username" label="账号" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.mark" class="red">{{
            scope.row.username
          }}</span>
          <span v-else>{{ scope.row.username }}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="tel" label="电话" width="120"></el-table-column>
      <el-table-column prop="email" label="邮箱" width="120"></el-table-column>
      <el-table-column prop="inviteBy" label="推荐人ID"></el-table-column>
      <el-table-column width="120" label="异常账号">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.mark"
            @change="handleUpdateMarkStatus(scope.row.id, $event)"
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="用户状态">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="scope.row.__userStatus && scope.row.__userStatus.color"
            >{{ scope.row.__userStatus && scope.row.__userStatus.text }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column width="100px" label="实名认证">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.idNoStatus !== 1"
            size="mini"
            :type="scope.row.__userStatus && scope.row.__idNoStatus.color"
            >{{ scope.row.__userStatus && scope.row.__idNoStatus.text }}</el-tag
          >
          <span v-if="scope.row.idNoStatus === 1">
            <div>{{ scope.row.idNo }}</div>
            <div>{{ scope.row.realName }}</div>
          </span>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="邮箱认证">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="
              scope.row.__emailSecurityStatus &&
              scope.row.__emailSecurityStatus.color
            "
          >
            {{
              scope.row.__emailSecurityStatus &&
              scope.row.__emailSecurityStatus.text
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="100px" label="手机认证">
        <template slot-scope="scope">
          <el-tag
            size="mini"
            :type="
              scope.row.__phoneSecurityStatus &&
              scope.row.__phoneSecurityStatus.color
            "
          >
            {{
              scope.row.__phoneSecurityStatus &&
              scope.row.__phoneSecurityStatus.text
            }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column width="110px" label="Google认证">
        <template slot-scope="scope">
          <el-button
            type="primary"
            v-if="scope.row.googleSecurityStatus"
            size="mini"
            @click="cancelGoo(scope.row.id)"
            >取消认证</el-button
          >
          <el-tag size="mini" v-else>未认证</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column
      width="120px"
      label="银行卡绑定状态">
      <template slot-scope="scope">
        <el-tag
          size="mini"
          :type="scope.row.__bankAuthStatus && scope.row.__bankAuthStatus.color"
        >
          {{scope.row.__bankAuthStatus && scope.row.__bankAuthStatus.text}}
        </el-tag>
      </template>
      </el-table-column>-->
      <el-table-column width="120px" label="是否迁移用户">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.oldOrNew === 'old'" type="success"
            >是</el-tag
          >
          <el-tag
            size="mini"
            v-else
            :type="
              scope.row.__userVolunteerStatus &&
              scope.row.__userVolunteerStatus.color
            "
            >否</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="用户类型" width="110">
        <template slot-scope="scope">
          <a
            v-if="scope.row.userType == 2"
            @click="handleUserType(scope.row)"
          >
            {{ userTypes[scope.row.userType] || userTypes["2"] }}
            <i class="el-icon-edit"></i>
          </a>
          <span v-else>
            {{ userTypes[scope.row.userType] || scope.row.userType }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="120" label="股东分红点亮状态">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.userDividendStatus"
            @change="handleUpdateDividendStatus(scope.row.id, $event)"
            active-color="#13ce66"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="设置节点">
        <template slot-scope="scope">
          <span v-if="!scope.row.node">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>-->
      <el-table-column label="冻结状态">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.userStatus == 0"
            size="mini"
            type="danger"
            @click="handleBlockingReason(true, scope.row.id)"
            >冻结</el-button
          >
          <el-button
            v-if="scope.row.userStatus == '-1'"
            size="mini"
            type="danger"
            plain
            @click="handleBlocking(false, scope.row.id)"
            >取消冻结</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="编辑" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column label="查询手机邮箱" fixed="right" width="100">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-search"
            circle
            @click="handleSearch(scope.row.id)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
    <update-dialog :val="userinfoDetail"></update-dialog>
    <el-dialog
      title="更新用户类型"
      :visible.sync="updateUserTypeDialogVisible"
      width="400px"
    >
      <el-select v-model="newUserType" class="user-type-select">
        <el-option
          v-for="item in convertUserTypeOptions"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        ></el-option>
      </el-select>
      <div slot="footer">
        <el-button @click="closeUserTypeDialog">取消</el-button>
        <el-button type="primary" @click="handleUpdateUserType">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="searchDialogVisible"
      title="谷歌验证码"
      width="300px"
      @close="handleCloseGoogle"
    >
      <el-form :model="form" ref="form" label-width="110px">
        <el-form-item
          label="谷歌验证码"
          prop="googleCode"
          :rules="[
            {
              required: true,
              message: '请输入谷歌验证码',
            },
          ]"
        >
          <el-input v-model.trim="form.googleCode"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleCloseGoogle">取消</el-button>
        <el-button type="primary" @click="handleGoogle">确定</el-button>
      </div>
    </el-dialog>
    <showdialog :userId="userId"></showdialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";
import showdialog from "../showdialog";

export default {
  name: "UserList",

  data() {
    return {
      userTypes: {
        1: "模拟盘用户",
        2: "普通用户",
        3: "特殊账户",
      },
      convertUserTypeOptions: [
        { value: "1", label: "模拟盘用户" },
        { value: "3", label: "特殊账户" },
      ],
      // userTypes: {
      //   1: '无效用户',
      //   2: '普通用户',
      //   3: '初级股东',
      //   4: '中级股东',
      //   5: '高级股东'
      // },
      updateUserTypeDialogVisible: false,
      searchDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      userId: "",
      form: {
        googleCode: "",
      },
    };
  },
  components: {
    Pagination,
    updateDialog,
    showdialog,
  },
  methods: {
    ...mapActions("userOldSimulation", [
      "updateVolunteer",
      "updateBlocking",
      "cancelGoogle",
      "updateUserType",
      "updateDividendStatus",
      "updateMark",
      "showAccount",
      "checkGoogle",
    ]),
    ...mapMutations("userOldSimulation", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
      "setAccountVisible",
    ]),
    // timestampToTime(timestamp) {
    //     var date = new Date(timestamp-28800000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000 28800000为8小时时差
    //     var Y = date.getFullYear() + '-';
    //     var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
    //     var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
    //     var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
    //     var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
    //     var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
    //     return Y+M+D+h+m+s;
    // },
    pageChanged(pagination) {
      this.$emit("refresh", pagination);
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
    handleSearch(userId) {
      this.userId = userId;
      this.searchDialogVisible = true;
    },

    setnote(value) {
      this.setdialogVisible(true);
      this.setnodedetail(value);
    },
    handleBlocking(isSet, id) {
      const message = isSet ? "确认将此用户冻结吗？" : "确认取消冻结吗？";
      this.$confirm(message, "提示", {
        type: "warning",
      }).then(() => {
        this.updateBlocking({
          id,
          status: isSet ? -1 : 0,
        }).then(() => {
          this.$message.success("设置成功！");
          this.$emit("refresh");
        });
      });
    },
    handleBlockingReason(isSet, id) {
      const message = "确认将此用户冻结吗？";
      this.$prompt("请输入冻结理由:", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        this.updateBlocking({
          id,
          status: isSet ? -1 : 0,
          content: value,
        }).then(() => {
          this.$message.success("操作成功！");
          this.$emit("refresh");
        });
      });
    },
    handleVolunteer(isSet, id) {
      const message = isSet
        ? "确认将此用户设为志愿者吗？"
        : "确认取消此志愿者吗？";
      this.$confirm(message, "提示", {
        type: "warning",
      }).then(() => {
        this.updateVolunteer({
          id,
          status: isSet ? 1 : 0,
        }).then(() => {
          this.$message.success("设置成功！");
          this.$emit("refresh");
        });
      });
    },
    cancelGoo(id) {
      const message = "确定取消该用户谷歌认证吗";
      this.$confirm(message, "提示", {
        type: "warning",
      }).then(() => {
        this.cancelGoogle({
          id: id,
        }).then(() => {
          this.$message.success("取消成功！");
          this.$emit("refresh");
        });
      });
    },
    handleUserType(user) {
      this.updateUserTypeDialogVisible = true;
      this.newUserType = "";
      this.selectedForUserType = user;
    },
    closeUserTypeDialog() {
      this.updateUserTypeDialogVisible = false;
      this.newUserType = "";
      this.selectedForUserType = {};
    },
    handleUpdateUserType() {
      this.updateUserType({
        id: this.selectedForUserType.id,
        userType: this.newUserType,
      }).then(() => {
        this.closeUserTypeDialog();
        this.$message.success("更新成功！");
        this.$emit("refresh");
      });
    },
    handleUpdateDividendStatus(id, status) {
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.updateDividendStatus({ id, status }).then(() => {
          this.$message.success("更新成功！");
          this.$emit("refresh");
        });
      });
    },
    handleUpdateMarkStatus(userId, mark) {
      this.$confirm("确认进行该操作吗？", "提示", {
        type: "warning",
      }).then(() => {
        this.updateMark({ userId, mark }).then(() => {
          this.$message.success("标记成功！");
          this.$emit("refresh");
        });
      });
    },
    handleCloseGoogle() {
      this.$refs.form.resetFields();
      this.searchDialogVisible = false;
    },
    handleGoogle() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.checkGoogle({ googleCode: this.form.googleCode }).then(
            ({ code, msg }) => {
              if (code > -1) {
                this.showAccount({ userId: this.userId });
                this.setAccountVisible(true);
                this.searchDialogVisible = false;
              } else {
                this.$message.error(msg);
              }
            }
          );
        }
      });
    },
  },
  computed: {
    ...mapGetters("userOldSimulation", ["userList"]),
    ...mapState("userOldSimulation", [
      "pagination",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
    ]),
  },
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
